module.exports = __webpack_public_path__ + "static/problem-cover-d596c539c92619ee5fe63e01f8cee13b.png";